import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "./styled";
import { StyledIconButton } from "../ComplexButton/styled";
import { useClassesRecalc } from "../../../Classification/hooks/useClassesRecalc";
import { ClassificationParameter } from "../../../../interfaces/classification";

export interface ClassifyButtonProps {
  name: ClassificationParameter;
  valueIndex?: number;
  mini?: boolean;
}

export const ClassifyButton: FC<ClassifyButtonProps> = ({ name, children, mini, valueIndex }) => {
  const { t } = useTranslation("common");
  const { calculateClassesRange } = useClassesRecalc();
  const tooltip = mini && t("symbolEditor.classifyByAttribute");

  const onClick = useCallback(() => {
    calculateClassesRange({ parameter: name, valueIndex });
  }, [calculateClassesRange, name, valueIndex]);

  const renderButton = useCallback(
    (ref?: (node: HTMLButtonElement) => void) => (
      <StyledIconButton kind={"classification"} innerRef={ref} onClick={onClick} fixedWidth={!children}>
        {children}
      </StyledIconButton>
    ),
    [children, onClick],
  );

  return tooltip ? <Tooltip content={tooltip}>{renderButton}</Tooltip> : renderButton();
};
